import React, { Component } from "react";
import CreatePersonForm from "../CreatePersonForm/CreatePersonForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CreatePersonPage
Description : Componente que contienen el formulario de la pantalla CreatePerson
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente CreatePersonForm
================================================================================ */
class CreatePersonPage extends Component{
    render(){
        return(
            <div>                    
                <CreatePersonForm/>
            </div>
        )   
    }
}

export default CreatePersonPage;